module.exports = __webpack_public_path__ + "img/point.75ce36d0.png";